// AUTO-GENERATED by scripts/write-build-info.mjs. Do not edit by hand.
// Regenerated on every build; gitignored.
export interface BuildInfo {
  readonly version: string;
  readonly sha: string;
  readonly branch: string;
  readonly builtAt: string;
  readonly repoUrl: string;
  readonly buildNumber: string;
}

export const BUILD_INFO: BuildInfo = {
  "version": "1.4.1",
  "sha": "c972b9a4748bbb30723492267681069e4182c1bd",
  "branch": "main",
  "builtAt": "2026-10-09T19:39:11.322Z",
  "repoUrl": "https://github.com/geevensingh/jotjson",
  "buildNumber": "747"
};
